import type { RouteRecordRaw } from "vue-router";

const routes: RouteRecordRaw[] = [
    {
        path: 'oidc-applications',
        meta: {
            breadcrumb: {
                key: 'oidcApplication.entity',
                plural: 2
            },
        },
        children: [
            {
                path: '',
                name: 'administration.oidc-applications',
                component: () => import("@/modules/oidc-applications/views/OidcApplicationsIndex.vue"),
            },
        ]
    },
];

export default routes;
